"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.unifyTouch = exports.toSvgXY = exports.mouse = exports.getSvgMatrixXY = exports["default"] = exports.SimpleScrollInfoType = exports.OffsetType = void 0;
var _createClass2 = _interopRequireDefault(require("reshow-runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("reshow-runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("reshow-runtime/helpers/defineProperty"));
var _getScrollInfo = _interopRequireDefault(require("get-scroll-info"));
var _getObjectValue = _interopRequireDefault(require("get-object-value"));
var _reshowConstant = require("reshow-constant");
//@ts-check
var Coordinate = /*#__PURE__*/(0, _createClass2["default"])(function Coordinate() {
  (0, _classCallCheck2["default"])(this, Coordinate);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "x", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "y", void 0);
});
/**
 * @param {object} e
 */
var unifyTouch = function unifyTouch(e) {
  return e && e.changedTouches ? (0, _getObjectValue["default"])(e, ["changedTouches", 0]) : e;
};

/**
 * @param {object} e
 * @param {HTMLElement} dom
 * @param {HTMLElement} scrollNode
 * @returns {[number, number]}
 */
exports.unifyTouch = unifyTouch;
var mouse = function mouse(e, dom, scrollNode) {
  if (!dom) {
    dom = e.currentTarget || e.target;
  }
  e = unifyTouch(e);
  var x = e.clientX;
  var y = e.clientY;
  var svgXY = toSvgXY(dom)(x, y);
  if ((0, _reshowConstant.OBJ_SIZE)(svgXY)) {
    var svgX = /** @type Coordinate */svgXY.x,
      svgY = /** @type Coordinate */svgXY.y;
    return [svgX, svgY];
  } else {
    var domXY = /** @type {OffsetType} */getOffset(dom, scrollNode);
    /**
     * dom.clientLeft
     *
     * https://www.w3schools.com/jsref/prop_element_clientleft.asp
     */
    return [x - domXY.left - dom.clientLeft, y - domXY.top - dom.clientTop];
  }
};

/**
 * @param {object} dom
 * @param {object} [zoom]
 */
exports.mouse = mouse;
var toSvgXY = function toSvgXY(dom, zoom) {
  return (
    /**
     * @param {number} x
     * @param {number} y
     * @returns {Coordinate|undefined}
     */
    function (x, y) {
      var svg = dom.ownerSVGElement || dom;
      if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        point.x = x;
        point.y = y;
        point = point.matrixTransform(dom.getScreenCTM().inverse());
        return getZoomXY(zoom)(point.x, point.y);
      }
    }
  );
};

/**
 * @param {object} dom
 * @param {object} zoom
 */
exports.toSvgXY = toSvgXY;
var getSvgMatrixXY = function getSvgMatrixXY(dom, zoom) {
  return (
    /**
     * @param {number} x
     * @param {number} y
     * @returns {Coordinate|undefined}
     */
    function (x, y) {
      var svg = dom.ownerSVGElement || dom;
      if (svg.getScreenCTM) {
        var _dom$getScreenCTM = dom.getScreenCTM(),
          a = _dom$getScreenCTM.a,
          b = _dom$getScreenCTM.b,
          c = _dom$getScreenCTM.c,
          d = _dom$getScreenCTM.d,
          e = _dom$getScreenCTM.e,
          f = _dom$getScreenCTM.f;
        var _svg$getBoundingClien = svg.getBoundingClientRect(),
          left = _svg$getBoundingClien.left,
          top = _svg$getBoundingClien.top;
        var svgX = a * x + c * y + e - left;
        var svgY = b * x + d * y + f - top;
        return getZoomXY(zoom)(svgX, svgY);
      }
    }
  );
};

/**
 * @param {object} zoom
 */
exports.getSvgMatrixXY = getSvgMatrixXY;
var getZoomXY = function getZoomXY(zoom) {
  return (
    /**
     * @param {number} x
     * @param {number} y
     * @returns {Coordinate}
     */
    function (x, y) {
      if (!zoom) {
        return {
          x: x,
          y: y
        };
      }
      var zoomK = (0, _getObjectValue["default"])(zoom, ["k"], 1);
      var zoomX = (0, _getObjectValue["default"])(zoom, ["x"], 0);
      var zoomY = (0, _getObjectValue["default"])(zoom, ["y"], 0);
      var zx = (x - zoomX) / zoomK;
      var zy = (y - zoomY) / zoomK;
      return {
        x: zx,
        y: zy
      };
    }
  );
};

/**
 * @param {object} dom
 * @returns {Coordinate}
 */
var getRectWithElOffset = function getRectWithElOffset(dom) {
  var x = 0;
  var y = 0;
  var el = dom;
  do {
    var offsetTop = el.offsetTop || 0;
    var offsetLeft = el.offsetLeft || 0;
    if ("BODY" === el.nodeName) {
      x += offsetLeft;
      y += offsetTop;
    } else {
      x += offsetLeft - el.scrollLeft;
      y += offsetTop - el.scrollTop;
    }
    el = el.offsetParent;
  } while (el);
  return {
    x: x,
    y: y
  };
};

/**
 * @typedef {import("get-scroll-info").ScrollInfoType} ScrollInfoType
 */
var SimpleScrollInfoType = /*#__PURE__*/(0, _createClass2["default"])(function SimpleScrollInfoType() {
  (0, _classCallCheck2["default"])(this, SimpleScrollInfoType);
  /**
   * @type {number}
   */
  (0, _defineProperty2["default"])(this, "top", void 0);
  /**
   * @type {number}
   */
  (0, _defineProperty2["default"])(this, "left", void 0);
});
exports.SimpleScrollInfoType = SimpleScrollInfoType;
var OffsetType = /*#__PURE__*/(0, _createClass2["default"])(function OffsetType() {
  (0, _classCallCheck2["default"])(this, OffsetType);
  /**
   * @type DOMRect
   */
  (0, _defineProperty2["default"])(this, "rect", void 0);
  /**
   * @type ScrollInfoType|SimpleScrollInfoType
   */
  (0, _defineProperty2["default"])(this, "scrollInfo", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "w", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "h", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "width", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "height", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "x", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "y", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "top", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "right", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "bottom", void 0);
  /**
   * @type number
   */
  (0, _defineProperty2["default"])(this, "left", void 0);
});
/**
 * @param {HTMLElement} dom
 * @param {HTMLElement|import('reshow-constant').SAFE_UNDEFINED} [scrollNode]
 * @returns {OffsetType|undefined}
 */
exports.OffsetType = OffsetType;
var getOffset = function getOffset(dom, scrollNode) {
  if (!dom) {
    return;
  }
  var top = 0;
  var left = 0;
  var w;
  var h;
  /**
   * @type DOMRect | any
   */
  var rect;
  /**
   * @type {ScrollInfoType|SimpleScrollInfoType}
   */
  var scrollInfo = 0 === scrollNode ? {
    top: 0,
    left: 0
  } : (0, _getScrollInfo["default"])( /** @type {HTMLElement}*/scrollNode);
  if (_reshowConstant.UNDEFINED !== typeof SVGElement && dom instanceof SVGElement) {
    rect = dom.getBoundingClientRect();
    top = rect.top + scrollInfo.top;
    left = rect.left + scrollInfo.left;
    w = rect.width;
    h = rect.height;
  } else {
    w = dom.offsetWidth;
    h = dom.offsetHeight;
    if (dom.getBoundingClientRect) {
      rect = dom.getBoundingClientRect();
      top = (rect.top + scrollInfo.top) * 1;
      left = (rect.left + scrollInfo.left) * 1;
      if (scrollNode) {
        var scrollRect = /**@type HTMLElement*/scrollNode.getBoundingClientRect();
        top -= scrollRect.top;
        left -= scrollRect.left;
      }
    } else {
      var rectOffset = getRectWithElOffset(dom);
      top = /** @type {number} */rectOffset.y;
      left = /** @type {number} */rectOffset.x;
    }
  }
  var result = {
    rect: rect,
    scrollInfo: scrollInfo,
    w: w,
    h: h,
    width: w,
    height: h,
    x: left,
    y: top,
    top: top,
    right: left + w,
    bottom: top + h,
    left: left
  };
  return result;
};
var _default = getOffset;
exports["default"] = _default;